import { render } from "./CartPage.vue?vue&type=template&id=9a8aade8&scoped=true"
import script from "./CartPage.vue?vue&type=script&lang=js"
export * from "./CartPage.vue?vue&type=script&lang=js"

import "./CartPage.vue?vue&type=style&index=0&id=9a8aade8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9a8aade8"

export default script